export default {
  RESEARCH({ commit }, payload) {
    commit("RESEARCH", payload);
  },
  SELECT({ commit }, payload) {
    commit("SELECT", payload);
  },
  RESET_STATE({ commit }, payload) {
    commit("RESET_STATE", payload);
  },
  TAG_FILTER({ commit }, payload) {
    commit("TAG_FILTER", payload);
  },
  REMOVE_TAG_FILTER({ commit }, payload) {
    commit("TAG_FILTER", payload);
    commit("REMOVE_TAG_FILTER", payload);
  },
  RESET_FOR_COLLECTION({ commit }, payload) {
    commit("RESET_FOR_COLLECTION", payload);
  },
  SET({commit}, payload) {
    commit('SET', payload)
  },
};
